// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export interface DeviationPlotParams {
  /** Raw data values (plotted in input order) */
  readonly data: number[];
}

// ---------------------------------------------------------------------------
// Display
// ---------------------------------------------------------------------------

export interface DeviationPlotDisplayConfig {
  /** Color for the connecting line and dots */
  readonly lineColor?: string;
  /** Color for deviations above the mean */
  readonly positiveColor?: string;
  /** Color for deviations below the mean */
  readonly negativeColor?: string;
}

export const DEFAULT_DEVIATION_PLOT_DISPLAY: DeviationPlotDisplayConfig = {
  lineColor: '#6366f1', // indigo-500
  positiveColor: '#6366f1', // indigo-500
  negativeColor: '#f43f5e', // rose-500
};
